const radii = {
  none: "0",
  sm: "var(--border-radius)",
  base: "var(--border-radius-2)",
  md: "var(--border-radius-3)",
  lg: "var(--border-radius-4)",
  xl: "var(--border-radius-5)",
  "2xl": "calc(var(--border-radius-5) * 1.5)",
  "3xl": "calc(var(--border-radius-5) * 2)",
  full: "9999px",
};

export default radii;
